import { SimpleBox } from "@components/ui-kit/SimpleBox";
import { t } from "@lingui/macro";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import React from "react";

interface SummaryProps {
  showOnlyTotalBudget: boolean;
  ourWork: number;
  plannedExpenses: number;
  plannedCommission: number;
  invoiced: number;
  totalBudget: number;
}

const Summary = (props: SummaryProps) => {
  const box = (label: string, value: number) => (
    <SimpleBox minWidth="20%">
      <span className="text-4xl font-bold">
        {currency.formatByWorkspace(value)}
      </span>
      <span className="text-xl mt-4">{label}</span>
    </SimpleBox>
  );

  return (
    <div className="flex justify-end lg:w-2/3 ml-auto">
      {!props.showOnlyTotalBudget && (
        <React.Fragment>
          {box(t`Work`, props.ourWork)}
          {box(t`Planned Expenses`, props.plannedExpenses)}
          {box(t`Planned Commission`, props.plannedCommission)}
          {box(t`Invoiced`, props.invoiced)}
        </React.Fragment>
      )}
      {box(t`Total budget`, props.totalBudget)}
    </div>
  );
};

export default observer(Summary);
